// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__zdcxF","productName":"Table_productName__28Vs0"};